"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const settlementRequestDataState_1 = __importDefault(require("@/room/settlement_request/settlementRequestDataState"));
const userInfoState_1 = __importDefault(require("@/common/components/NavHeader/userInfoState"));
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const _1 = require(".");
function default_1({ settlementRequestForm, isWithdrawRequest, }) {
    const { company_number, user_id: userId } = (0, recoil_1.useRecoilValue)(settlementRequestDataState_1.default);
    const { setValue } = settlementRequestForm;
    const { ready, channel_id } = (0, recoil_1.useRecoilValue)(userInfoState_1.default);
    (0, react_1.useEffect)(() => {
        if (ready) {
            let channelTaxType;
            try {
                channelTaxType = JSON.parse((0, functions_1.getCookie)('channel_tax_type'));
            }
            catch (_a) { }
            if (!!channelTaxType && !!channelTaxType[channel_id]) {
                const taxType = channelTaxType[channel_id];
                if (taxType === 1)
                    setValue('tax_type', 1);
                if (taxType === 2 && !!company_number)
                    setValue('tax_type', 2);
            }
            else {
                const prevTaxType = Number((0, functions_1.getCookie)('tax_type'));
                if (prevTaxType === 1)
                    setValue('tax_type', 1);
                if (prevTaxType === 2 && !!company_number)
                    setValue('tax_type', 2);
            }
        }
    }, [ready]);
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                    display: 'flex',
                    alignItems: 'center',
                    columnGap: '8px',
                    padding: '16px 16px 12px',
                } }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.WarningTriangleRedSvg, { css: { width: '20px', height: '20px' } }), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle3 gray-80" }, { children: t('정산 접수 시점에만 요청 가능해요') }))] })), (0, jsx_runtime_1.jsx)(_1.CashReceiptRequirement, { settlementRequestForm: settlementRequestForm, isWithdrawRequest: isWithdrawRequest, userId: userId }), (0, jsx_runtime_1.jsx)(_1.TaxInvoiceRequirement, { settlementRequestForm: settlementRequestForm })] }));
}
exports.default = default_1;
